import BaseApi from './BaseApi';

/**
 * API for retrieving token information
 */
const create = (handleUnauthorized) => { 
    
    const ApiPaths = {
        GET_VIR: (params) => `vir?taxYear=${params.taxYear}&vmId=${params.vmId}`,
        UPDATE_VIR: (params, lang) => `vir?taxYear=${params.taxYear}&vmId=${params.vmId}&lang=${lang}`,
    };

    const api = BaseApi.create({ unAuthorizedFunction: handleUnauthorized });
    
    const getVir = (params) => api.get(ApiPaths.GET_VIR(params));
    const updateVir = (params, lang) => api.put(ApiPaths.UPDATE_VIR(params, lang));

    // Return back a collection of functions
    return {
        getVir, updateVir
    }
}

// let's return back our create method as the default.
export default {
    create
}